
// Data Structure:
//
// {
// 		title: "Opening",				// <- title of the event/talk/session
// 		start: "13:00", 				// <- start time
// 		end: "14:00", 					// <- end time
//
// 		break: true, 					// <- optional: true | false
//
// 		location: "Room 1", 			// <- optional: location name
//		locationUrl: "https://....",	// <- optional: location URL
//
// 		speakerKey: "dr-mi..-al..", 	// <- optional: speaker key from /public/data/speakers.json
//    										  used to fetch "speaker", "affiliation", "speakerImage" and "details" (i.e. bio)
// 											  from speaker DB (coming from CMS)
//
// 		speaker: "Michael Alexander", 	// <- optional: speaker name <- overwrites speakerDB data when set
// 		affiliation: "TU Dresden", 		// <- optional: affiliation <- overwrites affiliation from speaker DB when set
// 		speakerImage: "../drma.jpg", 	// <- optional: speaker image path  <- overwrites speakerImage from speaker DB when set
// 		details: "<p>This talkwill be....</p>", // <- optional: any details in HTML format <- overwrites details (i.e. bio) from speaker DB when set
//
// },


const data = [
	{
		title: "Wed, May 14",
		date: "2025-05-14",
		UTCOffset: "+02:00",
		items: [
			{
				title: "Registration",
				start: "8:00",
				end: "9:00",
				location: "Main Foyer",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
				break: true,
			},
			{
				title: "Opening Session – Welcome Address",
				start: "9:00",
				end: "9:30",
                speaker: "Gerhard Fettweis (TU Dresden, BI), Jan M. Rabaey (UC Berkeley) and Gerd Teepe (Celtro)",
				location: "Hall 3 East",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
			},
			{
				title: "Opening Session – Semiconductor Perspective 2025 – What Is Left for Europe?",
				start: "9:35",
				end: "9:55",
                speakerKey: "dr-michael-alexander",
				location: "Hall 3 East",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
			},
			{
				title: "Opening Session – Startup Pitch – Revolutionary Data Converter Technology for Next Generation Wireless Communication",
				start: "9:55",
				end: "10:00",
                speaker: "Mohamed Saeed Elsayed, PhD",
                speakerImage: "../img/speakers/Mohamed-Elsayed.jpg",
                affiliation: "InCirT",
                details: "<p>InCirT develops revolutionary data converter solutions. Their technology can outperform state of the art by up to 100x in terms of bandwidth, 10x in terms of energy efficiency and their data converter solutions can be realized in standard semiconductor technology.  InCirT's solutions can significantly improve an array of applications including wireless communication, digital radars, optical communication, chip-to-chip communication or quantum computing.</p>",
				location: "Hall 3 East",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
			},
			{
				title: "Opening Session – Analysis of CMOS Embedded Non-Volatile Memory Solutions with the Promise to Take Neuromorphic Computing to the Edge",
				start: "10:00",
				end: "10:20",
                speakerKey: "kuntal-chowdhury",
				location: "Hall 3 East",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
			},
			{
				title: "Opening Session – Startup Pitch – BoostCore, a Novel European AI Accelerator, Adaptable, Efficient and Scalable",
				start: "10:20",
				end: "10:25",
                speaker: "Carsten Ahrens",
                speakerImage: "../img/speakers/Carsten-Ahrens.jpg",
                affiliation: "einstAIn",
                details: "<p>einstAIn is a European startup revolutionizing AI inference with scalable, adaptable, and energy-efficient hardware accelerators. The BoostCore design delivers state-of-the-art performance across edge and mobile platforms, powered by a novel bit-serial architecture that significantly boosts both throughput and energy efficiency. Designed in Europe, BoostCore will be offered as a flexible IP core and chiplet, enabling seamless integration into SoCs and multi-chip systems. With optimized support for modern AI workloads, einstAIn meets the rising demand for high-performance, low-power AI acceleration.</p>",
				location: "Hall 3 East",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
			},
			{
				title: "Coffee Break and Exhibition",
				start: "10:30",
				end: "11:30",
				break: true,
                location: "Hall 3 East, Hall 2",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
			},
			{
				title: "Design Session – System-Technology Co-Optimisation: Tackling Challenges Together",
				start: "11:30",
				end: "11:50",
                speakerKey: "dr-jo-de-boeck",
				location: "Hall 3 East",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
			},
			{
				title: "Design Session – The Evolving Landscape for Compound Semiconductor Devices and Beyond",
				start: "11:50",
				end: "12:10",
                speakerKey: "jin-bains",
				location: "Hall 3 East",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
			},
			{
				title: "Design Session – Future Technologies for Bridging Physical and Digital Worlds",
				start: "12:10",
				end: "12:30",
                speakerKey: "dr-serge-nicoleau-2",
				location: "Hall 3 East",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
			},
			{
				title: "Design Session – Intelligent Test for Semiconductor IC Validation and Production",
				start: "12:30",
				end: "12:50",
                speakerKey: "dr-chen-chang",
				location: "Hall 3 East",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
			},
			{
				title: "Lunch Break and Exhibition",
				start: "13:00",
				end: "14:30",
				break: true,
                location: "Hall 3 East, Hall 2",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
			},
			{
				title: "Application Session – MediaTek's Perspective: Key 6G Technologies to Enable Differentiated User Experience",
				start: "14:30",
				end: "14:50",
                speakerKey: "dr-doru-calin",
				location: "Hall 3 East",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
			},
			{
				title: "Application Session – HW Research Challenges for the 6G Era",
				start: "14:50",
				end: "15:10",
                speakerKey: "dr-magnus-frodigh-2",
				location: "Hall 3 East",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
			},
			{
				title: "Application Session – A New Automotive SoC Platform for the Next Generation Autonomous Driving Applications",
				start: "15:10",
				end: "15:30",
                speakerKey: "dr-jens-benndorf",
				location: "Hall 3 East",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
			},
			{
				title: "Application Session – \"Affordable Mass\" of Defense Electronics",
				start: "15:30",
				end: "15:50",
                speakerKey: "keith-lynn",
				location: "Hall 3 East",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
			},
			{
				title: "Coffee Break and Exhibition",
				start: "16:00",
				end: "17:00",
				break: true,
                location: "Hall 3 East, Hall 2",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
			},
			{
				title: "Closing Session – SAL's Mission in Semiconductor Research for European Industries",
				start: "17:00",
				end: "17:20",
                speakerKey: "dr-thomas-buchegger",
				location: "Hall 3 East",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
			},
			{
				title: "Closing Session – AI/ML at the Forefront of Semiconductor Evolution: Enhancing Design, Efficiency, and Performance",
				start: "17:20",
				end: "17:40",
                speakerKey: "ursula-menhart",
				location: "Hall 3 East",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
			},
			{
				title: "Closing Session – Panel Discussion – Chipping Away: Microelectronics Between Technology Opportunities and Policy Challenges in an Uncertain World",
				start: "17:40",
				end: "18:40",
                speaker: "Gerhard Fettweis (TU Dresden, BI), Jens Drews (GlobalFoundries), Serge Nicoleau (STM), Jin Bains (Mini-Circuits), Yankin Tanurhan (Synopsys)",
				location: "Hall 3 East",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
			},
			{
				title: "Closing Session – Closing Remarks",
				start: "18:40",
				end: "19:00",
                speaker: "Jens Drews (GlobalFoundries)",
				location: "Hall 3 East",
				locationUrl: "https://www.messe-dresden.de/en/organizer/site-plan",
			},
			// {
			// 	title: "End of Day",
			// 	start: "19:00",
			// 	// location: "Courtyard",
			// 	end: "19:30",
			// 	break: true,
			// },
			{
				title: "Social Dinner",
				start: "19:30",
				location: "Courtyard",
				end: "21:30",
				break: true,
			}
		]
	},

]

for (const day of data) {
	for (const item of day.items) {
		item.show = false
	}
}

export const programdata = data
